import i18n from '@/i18n/i18n'
import UserService from '@/services/admin/UserService.js'
import { build_query, errorMessage } from '@/utilities/helpers'

const { t } = i18n.global
export const allowedFilters = ['id', 'by_role', 'by_fullname_phone_email']

export const allowedIncludes = ''
export const allowedSorts = []
export const allowedAppends = 'fullname'

export const namespaced = true

export const state = {
  users: null,
  user: {},
  meta: null,
  roles: []
}
export const mutations = {
  SET_USERS(state, users) {
    state.users = users.data
    state.meta = users.meta
  },
  SET_USER(state, user) {
    state.user = user
  },
  UPDATE_USER(state, user) {
    state.user = user
  },
  ADD_USER(state, user) {
    state.users.push(user)
  },
  SET_ROLES(state, roles) {
    state.roles = roles
  }
}

export const getters = {
  getUser: state => {
    return state.user
  },
  getUsers: state => {
    return state.users
  },
  getUserById: state => id => {
    return state.users ? state.users.find(user => user.id === id) : false
  }
}

export const actions = {
  getUsers({ commit }, query) {
    query['default'] = true

    if (query.allowed_sorts) {
      allowedSorts.push(query.allowed_sorts)
    }
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise(resolve => {
      UserService.getUsers(newQuery).then(response => {
        commit('SET_USERS', response)
        resolve(response)
      })
    })
  },
  getInsideSalesUsers({ commit }, query) {
    return new Promise(resolve => {
      UserService.getInsideSalesUsers(query).then(response => {
        resolve(response.data)
      })
    })
  },
  getAllocationDepartmentUsers({ commit }, query) {
    return new Promise(resolve => {
      UserService.getAllocationDepartmentUsers(query).then(response => {
        resolve(response.data)
      })
    })
  },
  getUser({ commit, getters, state }, id) {
    if (id == state.user.id) {
      return state.user
    }

    let user = getters.getUserById(id)

    if (user) {
      commit('SET_USER', user)
      return user
    } else {
      return new Promise(resolve => {
        UserService.getUser(id).then(response => {
          commit('SET_USER', response.data)
          resolve(response)
        })
      })
    }
  },
  updateUser({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      UserService.updateUser(user.id, user)
        .then(response => {
          commit('UPDATE_USER', user)
          const notification = {
            type: 'success',
            message: t('store.shared.data_updated')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.data_update_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updatePassword({ dispatch }, user) {
    return new Promise((resolve, reject) => {
      UserService.updatePassword(user)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('views.retailer.account.password')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  prepare2FA({ commit, state, dispatch }, params) {
    return new Promise((resolve, reject) => {
      UserService.prepare2FA(params.id, params.mfaOption)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.data_update_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  disable2FA({ commit, state, dispatch }, id) {
    return new Promise((resolve, reject) => {
      UserService.disable2FA(id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.data_update_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  confirm2FA({ commit, state, dispatch }, params) {
    return new Promise((resolve, reject) => {
      UserService.confirm2FA(params.id, params.code, params.option)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.data_update_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  get2FARecoveryCodes({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      UserService.get2FARecoveryCodes(state.user.id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.data_update_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createUser({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      UserService.createUser(user)
        .then(response => {
          commit('ADD_USER', response)
          const notification = {
            type: 'success',
            message: t('store.shared.created', {
              element: t('views.retailer.users.index.new_user')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  giveAdminPrivileges({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      UserService.giveAdminPrivileges(state.user.id)
        .then(response => {
          commit('SET_USER', response.data)
          const notification = {
            type: 'success',
            message: t('store.admin.user.admin_privileges_given')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.user.admin_privileges_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  revokeAdminPrivileges({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      UserService.revokeAdminPrivileges(state.user.id)
        .then(response => {
          commit('SET_USER', response.data)
          const notification = {
            type: 'success',
            message: t('store.admin.user.admin_privileges_removed')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.user.admin_privileges_removing_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRoles({ commit }, id) {
    return new Promise(resolve => {
      UserService.getRoles(id).then(response => {
        commit('SET_ROLES', response.data)
        resolve(response.data)
      })
    })
  },
  attachRole({ commit, state, dispatch }, role) {
    return new Promise(resolve => {
      UserService.attachRole(state.user.id, role.id).then(response => {
        const notification = {
          type: 'success',
          message: t('store.shared.added', {
            element: t('store.admin.user.role')
          })
        }
        dispatch('notification/add', notification, {
          root: true
        })
        commit('SET_ROLES', response.data)
        resolve(response.data)
      })
    })
  },
  detachRole({ commit, state, dispatch }, role) {
    return new Promise(resolve => {
      UserService.detachRole(state.user.id, role.id).then(response => {
        const notification = {
          type: 'warning',
          message: t('store.shared.deleted', {
            element: t('store.admin.user.role')
          })
        }
        dispatch('notification/add', notification, {
          root: true
        })
        commit('SET_ROLES', response.data)
        resolve(response.data)
      })
    })
  },
  deleteUser({ commit, dispatch }, userId) {
    return new Promise((resolve, reject) => {
      UserService.deleteUser(userId)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('views.admin.users.user')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.delete_error', {
                element: t('views.admin.users.user')
              }) + ` ${errorMessage(err)}`
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
